import React, { ReactElement, useEffect, useState } from "react";
import { IParentSize, ISelectedNode, IState } from "../../../types";
import { useRealtimeValues } from "../../../system/websocketClient";
import EAFDiffPress from "./eafDiffPress";
import LrfDiffPress from "./lrfDiffPress";
import { useFetch } from "../../../system/useFetch";
import { DashboardSchemaType } from "../../interruptions/types";
import { useSelector } from "react-redux";


interface IProps {
  parentSize: IParentSize;
}

const scanInterval =  2000;
const tags = [
  "EAFLOG.COMPARTMENT_1_DIFF_PRESS",
  "EAFLOG.COMPARTMENT_2_DIFF_PRESS",
  "EAFLOG.COMPARTMENT_3_DIFF_PRESS",
  "EAFLOG.COMPARTMENT_4_DIFF_PRESS",
  "EAFLOG.COMPARTMENT_5_DIFF_PRESS",
  "EAFLOG.COMPARTMENT_6_DIFF_PRESS",
  "EAFLOG.COMPARTMENT_7_DIFF_PRESS",
  "EAFLOG.COMPARTMENT_8_DIFF_PRESS",
  "EAFLOG.COMPARTMENT_9_DIFF_PRESS",
  "EAFLOG.COMPARTMENT_10_DIFF_PRESS",
  "EAFLOG.COMPARTMENT_11_DIFF_PRESS",
  "EAFLOG.COMPARTMENT_12_DIFF_PRESS",
  "LRFLOG.COMPARTMENT_1_DIFF_PRESS",
  "LRFLOG.COMPARTMENT_2_DIFF_PRESS",
  "LRFLOG.COMPARTMENT_3_DIFF_PRESS",
  "LRFLOG.COMPARTMENT_4_DIFF_PRESS",
  "LRFLOG.OVERRALL_DIFF_PRESS",
  "EAFLOG.OVERALL_DIFFERENTIAL_PRESSURE"
];

const DifferentialPressures = ({ parentSize }: IProps): ReactElement => {
  const width = parentSize.width / 2 - 48;
  const [ realtimeDispatch, realtimeData ] = useRealtimeValues();
  const [ _retry, setRetry ] = useState(0);
  const selectedNode = useSelector<IState, ISelectedNode>(state => state.selectedNode);
  const { data: schemas } = useFetch<Record<DashboardSchemaType, any>>(
    {
      module: "dashboard",
      query: "getSchemaConfig",
      payload: {
        nodeID: selectedNode.nodeID,
        nodeType: selectedNode.type
      }
    });

  useEffect(() => {
    realtimeDispatch({
      tags,
      interval: scanInterval
    }, () => setRetry(prevState => prevState + 1));
  }, [realtimeDispatch, setRetry]);

  return (
    <div className="display-grid gap-2 p-2" style={{ ...parentSize, gridTemplateColumns: "1fr 1fr" }}>
      <EAFDiffPress realtimeData={realtimeData} schemas={schemas} width={width} />
      <LrfDiffPress realtimeData={realtimeData} schemas={schemas} width={width} />
    </div>
  );
};

export default DifferentialPressures;
